var render = function render(){var _vm=this,_c=_vm._self._c;return _c('LoginForm',{ref:"loginForm",attrs:{"fields":_vm.fieldsToShow,"logo-url":_vm.expandedLogoUrl,"logo-default":'https://generation-sis-assets.s3.eu-west-1.amazonaws.com/images/genex-logo-02.svg',"submitText":_vm.submitText,"data":{
    tenants: this.tenants,
  },"error":_vm.error,"help-text":"Need help?","state":_vm.state,"is-white-labeled":_vm.isWhiteLabeled},on:{"forgotPasswordClick":_vm.forgotPassword,"submitted":_vm.nextState,"help":_vm.help,"reset":_vm.reset}})
}
var staticRenderFns = []

export { render, staticRenderFns }